// 🚫 Legacy /saas/checkout monthly/yearly Stripe page — DEPRECATED 2026-05-19.
// Sellox now sells only 4 LIFETIME plans (Básico $350 / Negocio $899 / Empresa $1499 / Insignia $1999).
// New checkout flow: /pricing → start trial → /admin/lifetime (crypto USDT or Stripe).
// We keep this route alive so older marketing links still work; it just routes
// the user to the new pricing page.
import React, { useEffect } from "react";
import { tr } from '@/i18n/tr';
import { useNavigate, useSearchParams } from "react-router-dom";

export default function SaasCheckoutPage() {
  const navigate = useNavigate();
  useEffect(() => {
    // Funnel: send legacy /saas/checkout visitors to start a free trial.
    // After signup they reach /admin/lifetime-buyout where the 3 plans live.
    window.location.replace("/register?from=legacy_checkout");
  }, [navigate]);
  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-5xl mb-4">🔄</div>
        <h1 className="text-2xl font-bold mb-2">{tr('x_ecd041a0')}</h1>
        <p className="text-slate-400 text-sm">Sellox ahora ofrece sólo 4 planes vitalicios — sin suscripción mensual.</p>
      </div>
    </div>
  );
}

// Keep success page so Stripe webhook landings still render
export function SaasSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4">
      <div className="max-w-md text-center bg-slate-900 border border-emerald-700/40 rounded-2xl p-8">
        <div className="text-6xl mb-4">✅</div>
        <h1 className="text-2xl font-bold mb-2">{tr('x_9a8ed80b')}</h1>
        <p className="text-slate-400 text-sm mb-4">
          {sessionId ? "Tu tenant será activado en 1-2 minutos. Te enviaremos un WhatsApp con los datos de acceso."
                     : "Gracias por tu compra. Revisa tu correo y WhatsApp."}
        </p>
        <a href="/login" className="inline-block px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 rounded-lg font-semibold transition">
          {tr('x_52dc2f55')}
        </a>
      </div>
    </div>
  );
}
